import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'cradua-lessor-info-list-modal',
  templateUrl: './lessor-info-list-modal.component.html',
  styleUrls: ['./lessor-info-list-modal.component.scss']
})
export class LessorInfoListModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LessorInfoListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  ngOnInit(): void {
    // console.log('lessor info ', this.modalData.transformedLessorRepresentative)
  }

onClose() {
  this.dialogRef.close();
}

}
